.stats {
  padding: 56px 0 24px;
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 — white band directly under the blue hero */
}

/* Page intro, moved out of the hero to sit just above the stat cards. */
.stats__lede {
  font-family: sofia-pro, sans-serif; /* PRIMARY_FONT */
  font-size: 19px; /* HEADING_XS */
  line-height: 1.5;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0 0 40px;
}

.stats__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  border: var(--plume-border-card, 1px solid var(--color-primary-sand-200));
  border-radius: 18px;
  box-shadow: var(--plume-shadow-stats, 1px 2px 10px 0 rgba(89, 84, 78, 0.12));
  overflow: hidden;
}

.stats__item {
  padding: 38px 28px;
  border-right: 2px solid var(--color-primary-sand-200); /* PRIMARY_SAND_200 */
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.stats__item:last-child {
  border-right: none;
  position: relative; /* anchors the B Corp logo in the top-right corner */
}

.stats__num {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  /* HACK: fluid display size — candidate future DS heading scale */
  font-size: clamp(40px, 4.4vw, 58px);
  line-height: 1;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  letter-spacing: -0.02em;
}

.stats__item:nth-child(1) .stats__num {
  color: var(--color-primary-red-500); /* PRIMARY_RED_500 */
}

.stats__item:nth-child(2) .stats__num {
  color: var(--color-primary-blue-700); /* PRIMARY_BLUE_700 */
}

.stats__item:nth-child(4) .stats__num {
  color: var(--color-secondary-green-800); /* COMPLEMENTARY_GREEN */
}

.stats__label {
  font-size: 11px; /* COPY_XS */
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-primary-sand-900); /* PRIMARY_SAND_900 */
}

.stats__updatedAt {
  color: var(--color-primary-sand-900); /* PRIMARY_SAND_900 */
  font-size: 13px;
  margin: 18px 0 0;
  text-align: right;
}

/* B Corp certification logo, pinned to the top-right corner of the 4th stat cell (with margin). */
.stats__bcorpLogo {
  height: 82px;
  position: absolute;
  right: 24px;
  top: 40px;
  width: auto;
}

@media (max-width: 860px) {
  .stats__grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .stats__item:nth-child(2) {
    border-right: none;
  }

  .stats__item:nth-child(-n + 2) {
    border-bottom: 2px solid var(--color-primary-sand-200); /* PRIMARY_SAND_200 */
  }
}

@media (max-width: 560px) {
  .stats__grid {
    grid-template-columns: 1fr;
  }

  .stats__item {
    border-right: none;
    border-bottom: 1px solid var(--color-primary-sand-200); /* PRIMARY_SAND_200 */
  }

  .stats__item:nth-child(-n + 2) {
    border-bottom-width: 1px;
  }

  .stats__item:last-child {
    border-bottom: none;
  }
}
